import { cx } from "cva";
import { Headline } from "~/ui-library";
import { ChartPackLabel } from "~/components/ChartPackLabel";
import { FormattedDate } from "../FormattedDate";

export type ReportPreviewHeaderProps = {
  className?: string;
  kicker: string;
  headline: string;
  date: string | null;
  subhead: string | null;
  publicationInfo: string | null;
  darkMode: boolean;
  disableDate: boolean;
  isChartPack: boolean;
};

export const ReportPreviewHeader = ({
  className,
  kicker,
  headline,
  date,
  subhead,
  publicationInfo,
  darkMode,
  disableDate,
  isChartPack,
}: ReportPreviewHeaderProps) => {
  const showDate = date && !disableDate;

  return (
    <div className={cx(className, darkMode ? "dark" : null)}>
      <Headline
        level={6}
        blockCase
        className="text-primary sm:mb-xs md:mb-s lg:dark:text-gray-300"
      >
        {kicker}
      </Headline>
      {/* Headline needs special styles for desktop, and then shrink to headline 2 in mobile */}
      <h1
        className={cx(
          "mb-xs text-headline2 font-semibold leading-headline2",
          "md:mb-m md:text-headline0 md:leading-headline0",
          "lg:text-[3rem] lg:leading-[3.4rem] lg:dark:text-white",
          "xl:text-[3.375rem] xl:leading-[3.875rem]",
          "lg:max-w-[380px] xl:max-w-[620px]"
        )}
      >
        {headline}
      </h1>
      <div
        className={cx(
          "mb-m mt-0 text-body-regular text-gray-800",
          "md:mb-l md:text-[1.25rem]",
          "lg:dark:text-gray-300",
          "lg:max-w-[380px] xl:max-w-[620px]"
        )}
      >
        {subhead}
      </div>

      <div
        className={cx(
          "m-0 flex flex-col gap-s font-semibold text-gray-800",
          "lg:dark:text-gray-300"
        )}
      >
        <div className="flex items-center gap-xs">
          {showDate && (
            <FormattedDate
              date={new Date(date)}
              includeTZ={false}
              className="text-headline5 text-gray-900 lg:dark:text-white"
              dateFormat="MMMM yyyy"
            />
          )}
          {showDate && isChartPack && <div>&#8226;</div>}
          {isChartPack && (
            <div className="flex items-center">
              <ChartPackLabel
                bodySize="default"
                iconSize="small"
                className="font-semibold"
              />
            </div>
          )}
        </div>

        {publicationInfo && <div>{publicationInfo}</div>}
      </div>
    </div>
  );
};
